import { select } from 'd3';
import { range } from '../../core/utils/array';


export class EmptyBarGraph {
  private svg;

  constructor(
    private containerRef: any,
    private svgWidth: number,
    private svgHeight: number,
    private emptyPoints: number,
    private barWidth: number,
    private barSpacing: number,
    private barBackdrop: boolean
  ) {
  }

  drawBarGraph() {
    this.svg = select(this.containerRef).append('svg')
      .attr('width', this.svgWidth)
      .attr('height', this.svgHeight)
      .attr('fill', 'none')
      .attr('class', 'svgContainer')
      .append('g');

    this.svg.selectAll('.event_bar')
      .data(range(0, this.emptyPoints))
      .enter()
      .append('rect')
      .attr('x', (_d: any, index) => {
        return index * (this.barWidth + this.barSpacing + 0.15);
      })
      .attr('class', 'event_bar')
      .attr('width', this.barWidth)
      .attr('y', this.svgHeight - 1)
      .attr('height', 1);
  }
}
